import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Label,
  Button,
} from "reactstrap"
import { useParams } from "react-router-dom"
import Breadcrumbs from "components/Common/Breadcrumb"
import { sitename, API_URL } from "../../../constants/constants" // Ensure API_URL is imported
import axios from "axios" // Import axios
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"
import { useLocation, useHistory } from "react-router-dom"


const ViewFreeSpin = () => {
  const { id } = useParams() // Get the ID from the URL
  const [data, setData] = useState(null) // State to hold data

  const location = useLocation()
  const history = useHistory()
  // Accessing the passed data
  const { rowData } = location.state || {}
  // console.log(rowData)
  useEffect(() => {
    const fetchData = () => {
      axios
        .get(`${API_URL}/slotegrator/getfreeSpin`, {
          params: { freespin_id: id },
        })
        .then(response => {
          const fetchedData = response?.data || {}
          // console.log(response)
          setData(fetchedData)
        })
        .catch(error => {
          console.error("Error fetching free spin data:", error)
        })
    }

    fetchData()
  }, [id])

  if (!data) {
    return <p>Loading...</p> // Optional: Show a loading indicator while data is being fetched
  }
  // console.log(data)
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Admin" breadcrumbItem="Freebets" />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Detail</CardTitle>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Player ID</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.player_id ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Player Name</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {rowData.player_name ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Player Number</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {rowData.player_phone_number ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Game</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {rowData.game_name ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Provider Name</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {rowData.provider_name ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Currency</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.currency ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Quantity</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.quantity ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Quantity Left</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.quantity_left ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Valid From</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.valid_from
                          ? (() => {
                              const isUnix =
                                Number(data.valid_from) > 0 &&
                                Number(data.valid_from) < 10000000000
                              const date = isUnix
                                ? new Date(data.valid_from * 1000)
                                : new Date(data.valid_from)
                              return date.toLocaleString()
                            })()
                          : "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Valid Until</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.valid_until
                          ? (() => {
                              const isUnix =
                                Number(data.valid_until) > 0 &&
                                Number(data.valid_until) < 10000000000
                              const date = isUnix
                                ? new Date(data.valid_until * 1000)
                                : new Date(data.valid_until)
                              return date.toLocaleString()
                            })()
                          : "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Free Spin ID</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.freespin_id ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Free Spin UUID</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.freespin_uuid ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Bet ID</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.bet_id ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Denomination</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.denomination ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  {/* <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Deposit</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {rowData.deposit ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Product</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {rowData.product ?? "N/A"}
                      </p>
                    </Col>
                  </div> */}
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Game UUID</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.game_uuid ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Status</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.status ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Is Canceled</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.is_canceled ? "Yes" : "No"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Total Win</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {data.total_win ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col xs={6} sm={4} md={4} lg={6}>
                      <Label className="col-form-label">Created By</Label>
                    </Col>
                    <Col xs={6} sm={8} md={8} lg={6}>
                      <p className="text-muted fw-medium col-form-label">
                        {rowData.freespin_by_name ?? "N/A"}
                      </p>
                    </Col>
                  </div>
                  <div className="row mb-4">
                    <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                      <Button
                        type="button"
                        color="secondary"
                        className="w-100"
                        onClick={() => history.push("/promotions/freespin")}
                      >
                        Back
                      </Button>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default ViewFreeSpin
